/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-26 10:30:32
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-03 09:43:11
 */

const guidance = {
  tab: ['Business cooperation', 'Other cooperation'],
  des: 'Business cooperation, such as business requirements, landing scenarios, required product equipment, etc',
  form: {
    username: {
      label: 'Name'
    },
    telephone: {
      label: 'Telephone'
    },
    email: {
      label: 'Email'
    },
    company: {
      label: 'Organization name'
    },
    address: {
      label: 'Location'
    },
    consult: {
      label: 'Your question'
    },
    btn: 'Submit'
  },
  cards: [
    {
      label: 'Business cooperation',
      des: 'Email：yuhao.zhou@arteryflow.com '
    },
    {
      label: 'Investment and financing cooperation',
      des: 'Email：lei.zhang@arteryflow.com'
    },
    {
      label: 'Media cooperation',
      des: 'Email：luyao.shen@arteryflow.com'
    },
    {
      label: 'Problem feedback',
      des: 'Email：yongkuan.yang@arteryflow.com'
    }
  ]
}

export default guidance
